
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fastdebtconsolidation/privacy-policy",
      function () {
        return require("private-next-pages/fastdebtconsolidation/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fastdebtconsolidation/privacy-policy"])
      });
    }
  